import { openDB } from 'idb';

const DB_NAME = 'FileStorage';
const DB_VERSION = 1;
const STORE_NAME = 'files';

let dbInstance = null;

export async function initDatabase() {
  if (dbInstance) return dbInstance;

  dbInstance = await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (db.objectStoreNames.contains(STORE_NAME)) {
        db.deleteObjectStore(STORE_NAME);
      }
      db.createObjectStore(STORE_NAME);
    },
  });

  return dbInstance;
}

export function getDatabase() {
  return dbInstance;
}

export async function getFile(key) {
  if (!dbInstance) throw new Error('Database not initialized');
  return await dbInstance.get(STORE_NAME, key);
}

export async function saveFile(key, value) {
  if (!dbInstance) throw new Error('Database not initialized');
  const tx = dbInstance.transaction(STORE_NAME, 'readwrite');
  await tx.objectStore(STORE_NAME).put(value, key);
  await tx.done;
}

export async function deleteFile(key) {
  if (!dbInstance) throw new Error('Database not initialized');
  const tx = dbInstance.transaction(STORE_NAME, 'readwrite');
  await tx.objectStore(STORE_NAME).delete(key);
  await tx.done;
}

export async function clearAllFiles() {
  if (!dbInstance) throw new Error('Database not initialized');
  const tx = dbInstance.transaction(STORE_NAME, 'readwrite');
  await tx.objectStore(STORE_NAME).clear();
  await tx.done;
}

export async function getAllKeys() {
  if (!dbInstance) throw new Error('Database not initialized');
  return await dbInstance.getAllKeys(STORE_NAME);
}
